module.exports = __webpack_public_path__ + "assets/img/Travel_cover.5d8abc5f-ps.jpg";